import { render, staticRenderFns } from "./Polygon.vue?vue&type=template&id=ceaf3bc2"
import script from "./Polygon.vue?vue&type=script&lang=js"
export * from "./Polygon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports